function getGhStorageItem (key) {
  if(!window.localStorage.getItem('huaqi')) {
    window.localStorage.setItem('huaqi', '{}');
  };
  return JSON.parse(window.localStorage.getItem('huaqi'))[key]
}

function setGhStorageItem(key, value) {
  // TODO：0也会被转换成false，也会有可能jmyh是[object Object]
  if(!window.localStorage.getItem('huaqi')) {
    window.localStorage.setItem('huaqi', '{}')
  };
  var jmyhobj = JSON.parse(window.localStorage.getItem('huaqi'));
  jmyhobj[key] = value;
  // gh.setStorageItem('gh', jmyhobj)
  var str = JSON.stringify(jmyhobj)
  window.localStorage.setItem('huaqi', str)
}


function setStorageItem(key, obj) {
  var str = JSON.stringify(obj)
  window.localStorage.setItem(key, str)
};
function getStorageItem(key) {
  return JSON.parse(window.localStorage.getItem(key))
};


// 返回在vue模板中的调用接口
export default {
  getGhStorageItem :getGhStorageItem ,
  setGhStorageItem :setGhStorageItem,
  getStorageItem,
  setStorageItem
}


// WEBPACK FOOTER //
// ./src/common/js/api2.js